'use client';

import { c as _c } from "react/compiler-runtime";
import { useAuth } from '@repo/auth';
import { appPanels } from '@repo/features/right-panel';
import { type OrganisationCookies, OrganisationProvider, useOrganisationScope } from '@repo/features/organisations';
import { SdkProvider } from '@repo/sdk';
import { DbSessionProvider } from '@repo/tanstack/db';
import { ReactQueryStreamedHydration } from '@tanstack/react-query-next-experimental';
import { SidebarProvider, SiteHeaderProvider } from '@repo/ui/components';
import { UIProvider } from '@repo/ui/providers';
import { UpFetchProvider } from '@repo/upfetch';
import { EchoProvider } from '@repo/ws/provider';
import { ReactNode } from 'react';
import { queryHydration } from './query-hydration.ts';
export const Provider = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <SdkProvider data-sentry-element="SdkProvider" data-sentry-component="Provider" data-sentry-source-file="provider.tsx"><ReactQueryStreamedHydration {...queryHydration} data-sentry-element="ReactQueryStreamedHydration" data-sentry-source-file="provider.tsx"><UIProvider data-sentry-element="UIProvider" data-sentry-source-file="provider.tsx">{children}</UIProvider></ReactQueryStreamedHydration></SdkProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export const UserDbProvider = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  const {
    user
  } = useAuth();
  const t1 = user?.id ?? null;
  let t2;
  if ($[0] !== children || $[1] !== t1) {
    t2 = <DbSessionProvider userId={t1} data-sentry-element="DbSessionProvider" data-sentry-component="UserDbProvider" data-sentry-source-file="provider.tsx">{children}</DbSessionProvider>;
    $[0] = children;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export const AuthorizedProvider = t0 => {
  const $ = _c(5);
  const {
    children,
    organisationCookies
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <AuthorizedProviderContent data-sentry-element="AuthorizedProviderContent" data-sentry-source-file="provider.tsx">{children}</AuthorizedProviderContent>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== organisationCookies || $[3] !== t1) {
    t2 = <OrganisationProvider cookies={organisationCookies} data-sentry-element="OrganisationProvider" data-sentry-component="AuthorizedProvider" data-sentry-source-file="provider.tsx">{t1}</OrganisationProvider>;
    $[2] = organisationCookies;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
const AuthorizedProviderContent = t0 => {
  const $ = _c(8);
  const {
    children
  } = t0;
  const {
    token
  } = useAuth();
  const {
    scope
  } = useOrganisationScope();
  let t1;
  if ($[0] !== children) {
    t1 = <SidebarProvider className="bg-sidebar" defaultOpen={true} registry={appPanels} data-sentry-element="SidebarProvider" data-sentry-source-file="provider.tsx"><SiteHeaderProvider data-sentry-element="SiteHeaderProvider" data-sentry-source-file="provider.tsx">{children}</SiteHeaderProvider></SidebarProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1 || $[3] !== token) {
    t2 = <EchoProvider accessToken={token} data-sentry-element="EchoProvider" data-sentry-source-file="provider.tsx">{t1}</EchoProvider>;
    $[2] = t1;
    $[3] = token;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== scope || $[6] !== t2) {
    t3 = <UpFetchProvider scope={scope} data-sentry-element="UpFetchProvider" data-sentry-component="AuthorizedProviderContent" data-sentry-source-file="provider.tsx">{t2}</UpFetchProvider>;
    $[5] = scope;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};